/** This id is important and used in the ClickableShiftCell.tsx - used to toggle the highlighting of hovered cell of the same nurse */
export const MASTER_SCHEDULE_ROOT_ID = "master-schedule-v2-root";
